import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Action } from 'redux';
import {
  CreateSampleOrderSuccessResponse,
  ImageWithPositionPlaceHolder,
  Merch,
  ProductSample,
  SelectedPosition,
} from './state';
import {
  CatalogItem,
  ListCatalogResponse,
} from '@services/merch/types/api/list-catalog';
import { GetCatalogItemResponse } from '@services/merch/types/api/get-catalog-item';
import {
  UploadImageRequest,
  UploadImageResponse,
} from '@services/merch/types/api/upload-image';
import {
  CreateProductRequest,
  CreateProductResponse,
  RelativePosition,
  ShippingCostApiResponse,
} from '@services/merch/types/api/create-product';
import { UpdateProductRequest } from '@services/merch/types/api/update-product';
import { MerchProduct } from '@services/merch/types/api/merch-product';
import { MerchProductStatus } from '@services/merch/types/api/merch-product-status';

import { AssetFile } from '@common/types/data/asset-file';
import { CreateMerchOrderRequest } from '@services/merch/types/api/create-merch-order';

export class UpdateMerchStatus implements Action {
  readonly type = actions.UPDATE_MERCH_STATUS;

  constructor(public productId: string, public status: MerchProductStatus) {}
}

export class UpdateMerchStatusSuccess implements Action {
  readonly type = actions.UPDATE_MERCH_STATUS_SUCCESS;

  constructor(public product: MerchProduct) {}
}

export class ListMerchCatalog implements LoadingAction {
  readonly type = actions.LIST_MERCH_CATALOG;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class ListMerchCatalogSuccess implements LoadingAction {
  readonly type = actions.LIST_MERCH_CATALOG_SUCCESS;
  readonly isLoading = false;

  constructor(public catalog: ListCatalogResponse) {}
}

export class ListMerchCatalogError implements ErrorAction {
  readonly type = actions.LIST_MERCH_CATALOG_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListArtistMerch implements LoadingAction {
  readonly type = actions.LIST_ARTIST_MERCH;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string) {}
}

export class ListArtistMerchSuccess implements LoadingAction {
  readonly type = actions.LIST_ARTIST_MERCH_SUCCESS;
  readonly isLoading = false;

  constructor(public merch: MerchProduct[]) {}
}

export class ListArtistMerchError implements ErrorAction {
  readonly type = actions.LIST_ARTIST_MERCH_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateIsNewMerch implements LoadingAction {
  readonly type = actions.UPDATE_IS_NEW_MERCH;
  readonly isLoading = false;

  constructor(public isNewMerch: boolean) {}
}

export class UpdateMerch implements LoadingAction {
  readonly type = actions.UPDATE_MERCH;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public data: UpdateProductRequest,
    public productId: string,
    public artistId: string,
    public finish: boolean = false,
    public sampleOrder = false,
    public orderId = ''
  ) {}
}

export class UpdateMerchSuccess implements LoadingAction {
  readonly type = actions.UPDATE_MERCH_SUCCESS;
  readonly isLoading = false;

  constructor(public editProduct: MerchProduct) {}
}

export class UpdateMerchError implements ErrorAction {
  readonly type = actions.UPDATE_MERCH_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RedirectToMerchPage implements Action {
  readonly type = actions.REDIRECT_TO_MERCH_PAGE;

  constructor(public activeTab?: string, public route?: string) {}
}

export class RedirectToCatalogPage implements Action {
  readonly type = actions.REDIRECT_TO_CATALOG_PAGE;

  constructor(public tab?: string, public status?: string) {}
}

export class RedirectMerchSuccessPage implements Action {
  readonly type = actions.REDIRECT_MERCH_SUCCESS_PAGE;

  constructor(
    public productId: string,
    public tab?: string,
    public status?: string
  ) {}
}

export class FinishMerchLater implements LoadingAction {
  readonly type = actions.FINISH_MERCH_LATER;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class FinishMerchLaterSuccess implements LoadingAction {
  readonly type = actions.FINISH_MERCH_LATER_SUCCESS;
  readonly isLoading = false;
}

export class FinishMerchLaterError implements ErrorAction {
  readonly type = actions.FINISH_MERCH_LATER_ERROR;
  readonly isError = true;
  readonly isLoading = false;

  constructor(public code: string) {}
}

export class UpdateMerchStore implements Action {
  readonly type = actions.UPDATE_MERCH_STORE;

  constructor(public merch?: Partial<Merch>) {}
}

export class CleanMerchStore implements Action {
  readonly type = actions.CLEAN_MERCH_STORE;
}

export class CreateMerch implements LoadingAction {
  readonly type = actions.CREATE_MERCH;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public merch: CreateProductRequest, public artistId: string) {}
}

export class CreateMerchSuccess implements LoadingAction {
  readonly type = actions.CREATE_MERCH_SUCCESS;
  readonly isLoading = false;

  constructor(public merch: CreateProductResponse) {}
}

export class CreateMerchError implements ErrorAction {
  readonly type = actions.CREATE_MERCH_ERROR;
  readonly isError = true;
  readonly isLoading = false;

  constructor(public code: string) {}
}

export class EditMerch implements LoadingAction {
  readonly type = actions.EDIT_MERCH;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public productId: string) {}
}

export class EditMerchSuccess implements LoadingAction {
  readonly type = actions.EDIT_MERCH_SUCCESS;
  readonly isLoading = false;

  constructor(public editProduct: MerchProduct) {}
}

export class EditMerchError implements ErrorAction {
  readonly type = actions.EDIT_MERCH_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class DeleteMerch implements LoadingAction {
  readonly type = actions.DELETE_MERCH;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public productId: string) {}
}

export class DeleteMerchSuccess implements LoadingAction {
  readonly type = actions.DELETE_MERCH_SUCCESS;
  readonly isLoading = false;

  constructor(public productId: string) {}
}

export class DeleteMerchError implements ErrorAction {
  readonly type = actions.DELETE_MERCH_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class PublishProduct implements LoadingAction {
  readonly type = actions.PUBLISH_PRODUCT;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public productId: string) {}
}

export class PublishProductSuccess implements LoadingAction {
  readonly type = actions.PUBLISH_PRODUCT_SUCCESS;
  readonly isLoading = false;

  constructor(public productId: string) {}
}

export class PublishProductError implements ErrorAction {
  readonly type = actions.PUBLISH_PRODUCT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ChangeMerchDesignPosition implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_DESIGN_POSITION;
  readonly isLoading = true;
  readonly mainLoader = false;

  constructor(public position: RelativePosition) {}
}

export class ChangeMerchDesignPositionSuccess implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_DESIGN_POSITION_SUCCESS;
  readonly isLoading = false;
}

export class ChangeMerchDesignPositionError implements ErrorAction {
  readonly type = actions.CHANGE_MERCH_DESIGN_POSITION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ChangeMerchType implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_TYPE;
  readonly isLoading = true;
  readonly mainLoader = false;

  constructor(public product: CatalogItem) {}
}

export class ChangeMerchTypeSuccess implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_TYPE_SUCCESS;
  readonly isLoading = false;

  constructor(public product?: CatalogItem) {}
}

export class ChangeMerchTypeError implements ErrorAction {
  readonly type = actions.CHANGE_MERCH_TYPE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ChangeMerchColor implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_COLOR;
  readonly isLoading = true;
  readonly mainLoader = false;

  constructor(public colors: string[]) {}
}

export class ChangeMerchColorSuccess implements LoadingAction {
  readonly type = actions.CHANGE_MERCH_COLOR_SUCCESS;
  readonly isLoading = false;
}

export class ChangeMerchColorError implements ErrorAction {
  readonly type = actions.CHANGE_MERCH_COLOR_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AutoSaveMerch implements LoadingAction {
  readonly type = actions.AUTO_SAVE_MERCH;
  readonly isLoading = true;
}

export class AutoSaveMerchSuccess implements Action {
  readonly type = actions.AUTO_SAVE_MERCH_SUCCESS;
}

export class AutoSaveMerchError implements ErrorAction {
  readonly type = actions.AUTO_SAVE_MERCH_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetCatalogItem implements LoadingAction {
  readonly type = actions.GET_CATALOG_ITEM;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public itemId: number) {}
}

export class GetCatalogItemSuccess implements LoadingAction {
  readonly type = actions.GET_CATALOG_ITEM_SUCCESS;
  readonly isLoading = false;

  constructor(public data: GetCatalogItemResponse) {}
}

export class GetCatalogItemError implements ErrorAction {
  readonly type = actions.GET_CATALOG_ITEM_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class EditMerchImage implements Action {
  readonly type = actions.EDIT_MERCH_IMAGE;

  constructor(
    public data: Partial<Merch['image']>,
    public id: string | undefined
  ) {}
}

export class UploadMerchImage implements LoadingAction {
  readonly type = actions.UPLOAD_MERCH_IMAGE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public data: UploadImageRequest, public artistId: string) {}
}

export class UploadMerchImageSuccess implements LoadingAction {
  readonly type = actions.UPLOAD_MERCH_IMAGE_SUCCESS;
  readonly isLoading = false;

  constructor(public data: UploadImageResponse, public key: string) {}
}

export class UploadMerchImageError implements ErrorAction {
  readonly type = actions.UPLOAD_MERCH_IMAGE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateMerchOrder implements LoadingAction {
  readonly type = actions.UPDATE_MERCH_ORDER;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public newOrder: string[]) {}
}

export class UpdateMerchOrderSuccess implements LoadingAction {
  readonly type = actions.UPDATE_MERCH_ORDER_SUCCESS;
  readonly isLoading = false;

  constructor(public newOrder: string[]) {}
}

export class UpdateMerchOrderError implements ErrorAction {
  readonly type = actions.UPDATE_MERCH_ORDER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateMerchProductError implements Action {
  readonly type = actions.UPDATE_MERCH_PRODUCT_ERROR;

  constructor(
    public error: string,
    public field: string,
    public value?: string
  ) {}
}

export class UpdateMerchImages implements Action {
  readonly type = actions.UPDATE_MERCH_IMAGES;

  constructor(
    public images: Partial<
      UploadImageRequest &
        UploadImageResponse &
        ImageWithPositionPlaceHolder &
        Partial<AssetFile>
    >[]
  ) {} //here give the array of images so that we can update the redux store as well while updating the positions
}

export class UpdateMerchProductPosition implements Action {
  readonly type = actions.UPDATE_MERCH_PRODUCT_POSITION;

  constructor(public position: SelectedPosition) {}
}

export class ValidateMerchProductSample implements LoadingAction {
  readonly type = actions.VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER;
  readonly isLoading = true;

  constructor(public data: ProductSample) {}
}

export class ValidateMerchProductSampleSuccess implements LoadingAction {
  readonly type = actions.VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER_SUCCESS;
  readonly isLoading = false;
}

export class ValidateMerchProductSampleError implements LoadingAction {
  readonly type = actions.VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateMerchProductSample implements LoadingAction {
  readonly type = actions.UPDATE_MERCH_PRODUCT_SAMPLE_ORDER;
  readonly isLoading = false;

  constructor(public data: ProductSample) {}
}

export class CreateSampleOrder implements LoadingAction {
  readonly type = actions.CREATE_MERCH_PRODUCT_SAMPLE_ORDER;
  readonly isLoading = true;
}

export class CreateSampleOrderSuccess implements LoadingAction {
  readonly type = actions.CREATE_MERCH_PRODUCT_SAMPLE_ORDER_SUCCESS;
  readonly isLoading = false;

  constructor(public data: CreateSampleOrderSuccessResponse) {}
}

export class CreateSampleOrderError implements LoadingAction {
  readonly type = actions.CREATE_MERCH_PRODUCT_SAMPLE_ORDER_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetShippingCost implements LoadingAction {
  readonly type = actions.GET_MERCH_SAMPLE_ORDER_SHIPPING_COST;
  readonly isLoading = true;

  constructor(public data: CreateMerchOrderRequest) {}
}

export class GetShippingCostSuccess implements LoadingAction {
  readonly type = actions.GET_MERCH_SAMPLE_ORDER_SHIPPING_COST_SUCCESS;
  readonly isLoading = false;

  constructor(public data: ShippingCostApiResponse) {}
}

export class GetShippingCostError implements LoadingAction {
  readonly type = actions.GET_MERCH_SAMPLE_ORDER_SHIPPING_COST_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export type MerchActions =
  | UpdateMerchStatus
  | UpdateMerchStatusSuccess
  | ListMerchCatalog
  | ListMerchCatalogSuccess
  | ListMerchCatalogError
  | ListArtistMerch
  | ListArtistMerchSuccess
  | ListArtistMerchError
  | UpdateMerchStore
  | CleanMerchStore
  | UpdateMerch
  | UpdateMerchSuccess
  | UpdateMerchError
  | RedirectToMerchPage
  | RedirectToCatalogPage
  | RedirectMerchSuccessPage
  | FinishMerchLater
  | FinishMerchLaterSuccess
  | FinishMerchLaterError
  | CreateMerch
  | CreateMerchSuccess
  | CreateMerchError
  | EditMerch
  | EditMerchSuccess
  | EditMerchError
  | DeleteMerch
  | DeleteMerchSuccess
  | DeleteMerchError
  | GetCatalogItem
  | GetCatalogItemSuccess
  | GetCatalogItemError
  | UploadMerchImage
  | UploadMerchImageSuccess
  | UploadMerchImageError
  | EditMerchImage
  | PublishProduct
  | PublishProductSuccess
  | PublishProductError
  | UpdateMerchOrder
  | UpdateMerchOrderSuccess
  | UpdateMerchOrderError
  | ChangeMerchDesignPosition
  | ChangeMerchDesignPositionSuccess
  | ChangeMerchDesignPositionError
  | AutoSaveMerch
  | AutoSaveMerchSuccess
  | AutoSaveMerchError
  | ChangeMerchType
  | ChangeMerchTypeSuccess
  | ChangeMerchTypeError
  | ChangeMerchColor
  | ChangeMerchColorSuccess
  | UpdateMerchImages
  | UpdateMerchProductPosition
  | ValidateMerchProductSample
  | ValidateMerchProductSampleSuccess
  | ValidateMerchProductSampleError
  | ChangeMerchColorError
  | UpdateMerchProductSample
  | CreateSampleOrder
  | CreateSampleOrderSuccess
  | CreateSampleOrderError
  | GetShippingCost
  | GetShippingCostSuccess
  | GetShippingCostError
  | UpdateIsNewMerch;
